import { useNavigate, useOutletContext } from 'react-router-dom';
import SendToSignatureModal from './SendToSignatureModal';

interface ContractCreateContext {
    contractId: string;
    operationNumber: string;
    fileName: string;
}

export default function SendToSignatureModalRoute() {
    const navigate = useNavigate();
    const context = useOutletContext<ContractCreateContext>();

    if (!context?.contractId) {
        navigate('/contract/create', { replace: true });
        return null;
    }

    return (
        <SendToSignatureModal
            contractId={context.contractId}
            operationNumber={context.operationNumber}
            fileName={context.fileName}
            onClose={() => navigate('/contract/create', { replace: true })}
            onSuccess={(processId) => navigate(`/signature/${processId}`, { replace: true })}
        />
    );
}
